import * as React from 'react'

import CheckboxFilter from './CheckboxFilter'
import JeansFilter, { isJeansFilter } from './JeansFilter'
import PriceFilter from './PriceFilter'
import { TweakwiseNavigationFacet } from '../../../../graphql/schema.generated'

interface Props {
    filter: TweakwiseNavigationFacet
    value: string[]
    onChange(value: string[]): void
}

const TweakwiseFilterInput = ({
    filter,
    value,
    onChange,
    ...others
}: Props) => {
    switch (filter.facetSettings.selectionType) {
        case 'checkbox': {
            const Component = isJeansFilter(filter)
                ? JeansFilter
                : CheckboxFilter

            return (
                <Component
                    filter={filter}
                    value={value}
                    onChange={onChange}
                    {...others}
                />
            )
        }
        case 'slider': {
            // TODO: Generic slider filter that only uses the "price" layout on price key/css class
            const priceFilterValues = filter.attributes.filter(
                (attribute) => !attribute.isSelected,
            )
            const min = Number(priceFilterValues?.[0].title)
            const max = Number(priceFilterValues?.[1].title)

            const price =
                value && value.length > 0
                    ? value[0].split('-').map(Number)
                    : [min, max]

            if (price[0] < min) {
                price[0] = min
            }
            if (price[1] > max) {
                price[1] = max
            }
            return (
                <PriceFilter
                    min={min}
                    max={max}
                    value={price}
                    onChange={(values: number[]) =>
                        onChange([`${values[0]}-${values[1]}`])
                    }
                    {...others}
                />
            )
        }
        // TODO: case 'TweakwiseSwatchFilter':
        default:
            throw new Error(
                `Filter not supported: ${filter.facetSettings.selectionType}`,
            )
    }
}

export default TweakwiseFilterInput
